cb.define(['common/common_VM.Extend.js'], function (common) {
  var RM_rm_retailvouch_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
		var btnCheckModel = viewmodel.get('btnCheck');
		if(btnCheckModel != null)
		{
			btnCheckModel.setState('valueField', 'iGatheringid');
			btnCheckModel.setState('textField', 'gatheringName');
		}
		viewmodel.addProperty('fNoGatheringMoney', new cb.models.SimpleModel());
			var self = this;
			viewmodel.on('afterLoadData', function (data){
			common.initRegionAndPosition(viewmodel);
			var mode = viewmodel.getParams().mode;
			if(mode == 'browse')
			{
				
				if(btnCheckModel != null)
				{
					btnCheckModel.setState('dataSourceMode', 'remote');
					btnCheckModel.setDataSource({
					url: 'bill/queryGatherVouch',
					method: 'GET'
					}, { id: viewmodel.get('id').getValue(),billnum: 'rm_retailvouch' });
				}
			}
			var fPresellPayMoney = viewmodel.get('fPresellPayMoney').getValue();
			var fMoneySum = viewmodel.get('fMoneySum').getValue();
			var fbitSettle = viewmodel.get('fbitSettle').getValue();
			if(fbitSettle)
			{
				viewmodel.get('btnEdit').setVisible(false);
			}

			var price = 0;
			var amountofdecimal = cb.rest.AppContext.option.amountofdecimal;
			price = parseFloat(parseFloat(fMoneySum) - parseFloat(fPresellPayMoney)).toFixed(2);
			if(parseFloat(amountofdecimal).toString() != "NaN")
			{
				price = parseFloat(parseFloat(fMoneySum) - parseFloat(fPresellPayMoney)).toFixed(amountofdecimal);
			}
			
			var money = viewmodel.get('fNoGatheringMoney');
			money.setValue(price);
			money.setReadOnly(true);
			var PresellState = viewmodel.get('iPresellState').getValue();
			var DeliveryState = viewmodel.get('iDeliveryState').getValue();
			if(PresellState === 1 && DeliveryState === 0)
			{}else{
				viewmodel.get('cDeliveradd').setDisabled(true);
				viewmodel.get('cCusperson').setDisabled(true);
				viewmodel.get('cMobileNo').setDisabled(true);
				viewmodel.get('region').setDisabled(true);
			}

		});
      viewmodel.on('uquery', function (args) {
		var code = args.params;
		if(code != undefined)
		{
			var params = {
				mode: 'edit',
				readOnly: true,
				id: code
			};
			var data = {
				billtype: 'voucher',
				billno: 'rm_gatheringvouch',
				params: params
			};
			  cb.loader.runCommandLine('bill', data, viewmodel)
		}
      });
	  viewmodel.on('relating', function () {
		 // debugger;
        var proxy = cb.rest.DynamicProxy.create({
          settle: { url: 'bill/relating', method: 'GET' }
        });
        var params = {
			billnum : "rm_retailvouch",
			id: viewmodel.get('id').getValue()
        };
        proxy.settle(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
		  if (result != undefined) {
			 var resInfo = JSON.parse(result);

			 var params = {
				 mode: 'edit',
				 readOnly: true,
				 id: resInfo
			 };
			 var data = {
				 billtype: 'voucher',
				 billno: 'rm_retailvouch',
				 params: params
			 };
			 cb.loader.runCommandLine('bill', data, viewmodel)
		  }else{
			  cb.utils.alert('没有关联单据','error');
		  }

        });
      });
	  viewmodel.on('beforeLoad', function (data){
		data.isDistinct=true;
	  });
    },

  }
  try {
    module.exports = RM_rm_retailvouch_VM_Extend;
  } catch (error) {

  }
  return RM_rm_retailvouch_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_retailvouch_VM.Extend.js